import React from 'react';
import { Loader, Typography } from 'fronton-react';
import { LoadingWrapper } from './styles';

interface ILoadingProps {
  text: string;
}

export const Loading: React.FC<ILoadingProps> = ({ text }) => {
  return (
    <LoadingWrapper>
      <Typography variant="s" size="body_long" color="text-primary">
        {text}
      </Typography>
      <Loader size="m" variant="primary" />
    </LoadingWrapper>
  );
};
